import Agent from "./Agent.config";
import Builder from "./Builder.config";
import Company from "./Company.config";
import Plan from "./Plan.config";
import Subscription from "./Subscription.config";
import FeaturesConfig from "./features.config";


const dynamicForm = {
  company: Company,
  builder: Builder,
  agent: Agent,
  feature:FeaturesConfig,
  plan:Plan,
  subscription: Subscription
};

export default dynamicForm;
